// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37hEc","Support":"Footer_Support__1y1Bp","Images":"Footer_Images__1ECb7","Image":"Footer_Image__1FA6N"};